import { TIMEZONES } from 'helpers/timezones';
import { Timezone } from 'timezones.json';

export function getTimezone(name: string | null): Timezone | null {
  const timezone = TIMEZONES.find((t: Timezone) => t.utc[0] === name);

  return timezone ? timezone : null;
}
